import { Dialog } from "@sso/constant";

import { DeleteApiAccountKeyDialog } from "./apiAccountKey/delete";
import { ApiAccountProductDialog } from "./ApiAccountProduct";
import { GenetrateApiKeysDialog } from "./GenerateAPI";
import LicenceAddDialog from "./Licences/add";
import LicenceDeleteDialog from "./Licences/delete";
import LicenceEditDialog from "./Licences/edit";
import LicenceInfoDialog from "./Licences/info";
import LicenceTypeAddDialog from "./LicenceType/add/add";
import LicenceTypeDelete from "./LicenceType/delete";
import EditLicenceType from "./LicenceType/edit";
import { MergeOrganisationsDialog } from "./MergeOrganisations";
import OrderDetailsDialog from "./Order/Details";
import { OrganisationDialog } from "./Organisation";
import { DeleteOrganisationDialog } from "./Organisation/Delete";
import PricingDialog from "./Pricing";
import AddPricingCurrencyDialog from "./Pricing/addCurrency";
import { DeletePricingDialog } from "./Pricing/delete";
import PricingEditDialog from "./Pricing/edit";
import EditMultiCurrencyPricing from "./Pricing/editMultiCurrencyPricing";
import { UserDialog } from "./User";
import { DeleteUserDialog } from "./User/Delete";
import { UserProductDialog } from "./UserProduct";
import { UserResetPasswordDialog } from "./UserResetPassword";

interface DialogsContent {
  component: () => JSX.Element | null;
  maxWidth?: string;
}

export const dialogsObject: Record<Dialog, DialogsContent> = {
  [Dialog.ADD_ORGANISATION]: { component: OrganisationDialog },
  [Dialog.EDIT_ORGANISATION]: { component: OrganisationDialog },
  [Dialog.DELETE_ORGANISATION]: { component: DeleteOrganisationDialog },
  [Dialog.MERGE_ORGANISATIONS]: { component: MergeOrganisationsDialog },

  [Dialog.ADD_USER]: { component: UserDialog },
  [Dialog.EDIT_USER]: { component: UserDialog },
  [Dialog.DELETE_USER]: { component: DeleteUserDialog },
  [Dialog.USER_RESET_PASSWORD]: { component: UserResetPasswordDialog },

  [Dialog.USER_PRODUCT]: { component: UserProductDialog },

  [Dialog.GENERATE_API_KEYS]: { component: GenetrateApiKeysDialog },
  [Dialog.API_ACCOUNT_PRODUCT]: { component: ApiAccountProductDialog },
  [Dialog.CLOSE]: { component: () => null },
  [Dialog.DELETE_API_ACCOUNT_KEY]: { component: DeleteApiAccountKeyDialog },
  [Dialog.ADD_LICENCE]: { component: LicenceAddDialog },
  [Dialog.EDIT_LICENCE]: { component: LicenceEditDialog },
  [Dialog.DELETE_LICENCE]: { component: LicenceDeleteDialog },
  [Dialog.INFO_LICENCE]: { component: LicenceInfoDialog },
  [Dialog.ADD_LICENCE_TYPE]: { component: LicenceTypeAddDialog },
  [Dialog.DELETE_LICENCE_TYPE]: { component: LicenceTypeDelete },
  [Dialog.EDIT_LICENCE_TYPE]: { component: EditLicenceType },

  [Dialog.ADD_PRICING]: { component: PricingDialog },
  [Dialog.EDIT_PRICING]: { component: PricingEditDialog },
  [Dialog.DELETE_PRICING]: { component: DeletePricingDialog },
  [Dialog.PRICING_ADD_CURRENCY_RULES]: { component: AddPricingCurrencyDialog },
  [Dialog.EDIT_MULTI_CURRENCY_PRICING]: { component: EditMultiCurrencyPricing }, // Placeholder for multi-currency pricing edit dialog

  [Dialog.DETAILS_ORDER]: { component: OrderDetailsDialog },
};
